import React from "react";
import { connect } from "react-redux";
import {
    Row,
    Col,
    Label
} from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";

class VideoSettings extends React.Component {
    state = {
        isMediaVaultOpen: false
    };
    handleSoftUpdate = element => {
        const { dispatch, enviroment, page } = this.props;
        if (enviroment === sourceTypes.FORM)
            dispatch(formActions.updateFormElement(element));
        if (enviroment === sourceTypes.PAGE)
            dispatch(pageActions.updatePageElement(element, null, page));
        if (enviroment === sourceTypes.TEMPLATE) {
            const template = deepClone(this.props.template);
            const newTemplate = templateHelper.handleElementUpdates(
                element,
                template
            );
            dispatch(templateActions.softUpdate(newTemplate));
        }
    };

    toggle = (tabPane, tab) => {
        const newArray = this.state.activeTab.slice();
        newArray[tabPane] = tab;
        this.setState({
            activeTab: newArray
        });
    };
    handleChange = (e, val, path) => {
        const names = path.split(".");
        const element = deepClone(this.props.selectedElement);
        let value = null;
        if (val && val.hex !== undefined) {
            const { r, g, b, a } = val.rgb;
            value = `rgba(${r},${g},${b},${a})`;
        } else if (val) value = val;
        else if (e !== null) value = e.target.value;
        else return;
        if (names.length === 2) {
            element[names[0]][names[1]] = value;
        } else if (names.length === 3) {
            element[names[0]][names[1]][names[2]] = value;
        } else if (names.length === 4) {
            element[names[0]][names[1]][names[2]][names[3]] = value;
        }
        this.handleSoftUpdate(element);
    }

    toggleMediaVault = () => {
        this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
    };
    render() {
        const { selectedElement } = this.props;
        return (
            <div>
                <ListExpansion
                    footer={false}
                    icon="fa fa-image"
                    description="VideoSettings"
                    defaultExpanded={true}
                >
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="VideoSrc" />
                            </Label>
                        </Col>
                    </Row>
                    <UrlMultiInput margin={false} externalSourceOnly={true} onChange={this.handleChange} path={'props.value'} url={selectedElement.props.value} />
                    <br/>
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="ThumnailImage" />
                            </Label>
                        </Col>
                    </Row>
                    <UrlMultiInput setImage={(url) => this.handleChange(null, url, 'data.thumbnail')} margin={false} externalSourceOnly={false} onChange={this.handleChange} path={'data.thumbnail'} url={selectedElement.data.thumbnail || ''} />
                    <hr />
                    <EditorSlider
                        value={selectedElement.data.style.width !== undefined &&
                            selectedElement.data.style.width !== "unset"
                            ? parseFloat(selectedElement.data.style.width)
                            : 0}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["%"]}
                        activeUnit={'%'}
                        steps={1}
                        attachUnit={true}
                        max={100}
                        min={1}
                        path={'data.style.width'}
                        label="VideoWidth"
                    />
                    <hr />
                    <EditorSlider
                        value={selectedElement.data.style.height !== undefined &&
                            selectedElement.data.style.height !== "unset"
                            ? parseFloat(selectedElement.data.style.height)
                            : 0}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        steps={1}
                        max={1000}
                        attachUnit={true}
                        min={1}
                        path={'data.style.height'}
                        label="VideoHeight"
                    />
                    <hr />
                    <AlignmentButtonGroup
                        onChange={this.handleChange}
                        alignment={selectedElement.data.alignment}
                        path="data.alignment"
                        type={["left", 'center', 'right']}
                    />
                </ListExpansion>
            </div >
        );
    }
}
function mapStateToProps(state) {
    const { enviroment } = state.cms;
    let selectedElement = null;
    if (enviroment === sourceTypes.FORM)
        selectedElement = state.form.selectedElement;
    if (enviroment === sourceTypes.PAGE)
        selectedElement = state.page.selectedElement;
    if (enviroment === sourceTypes.TEMPLATE)
        selectedElement = state.template.selectedElement;
    return {
        enviroment: enviroment,
        template: state.template.template,
        form: state.form,
        page: state.page,
        selectedElement: selectedElement
    };
}
export default connect(mapStateToProps)(VideoSettings);
